import React, { useState } from 'react'
import { Users, BarChart3 } from 'lucide-react'
import StudentManager from './StudentManager'
import TeacherStats from './TeacherStats'

// Tab "Học sinh" của GV: Quản lý lớp/HS (dùng chung PMaker) + Thống kê tiến độ học tập.
const TeacherStudentsTab: React.FC = () => {
  const [view, setView] = useState<'manage' | 'stats'>('manage')
  return (
    <div>
      <div className="flex gap-2 border-b border-gray-200">
        <button
          onClick={() => setView('manage')}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-bold border-b-2 transition-colors ${view === 'manage' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
        >
          <Users size={16} /> Quản lý lớp & học sinh
        </button>
        <button
          onClick={() => setView('stats')}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-bold border-b-2 transition-colors ${view === 'stats' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
        >
          <BarChart3 size={16} /> Thống kê tiến độ
        </button>
      </div>
      {view === 'manage' ? <StudentManager /> : <div className="mt-6"><TeacherStats /></div>}
    </div>
  )
}

export default TeacherStudentsTab
